/**
 * Persian-digit formatting — the ONE home (E13-06). Before this, ~10 web files hand-rolled `fa()` in three
 * divergent shapes (regex digit-swap, `toLocaleString('fa-IR')`, and `(n, d=0)` with fraction digits). Two
 * distinct jobs, two functions:
 *   - toFaDigits: swap ASCII digits → Persian in an already-formatted string (dates, ids). No grouping.
 *   - faNum:      format a NUMBER in the fa-IR locale (grouping + `digits` fraction places, default 0).
 */
/** ASCII digits → Persian digits in any string. Use for dates/ids/pre-formatted text, not raw numbers. */
export function toFaDigits(s) {
    return String(s).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]);
}
/** A number in the fa-IR locale — thousands grouping + exactly `digits` fraction places (default 0). */
export function faNum(n, digits = 0) {
    return n.toLocaleString('fa-IR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
}
//# sourceMappingURL=faDigits.js.map